import { AccessType } from "@components/Exclusives/FeedAccess/AccessCarousel/types";
import { IconName } from "@components/LIcon";

type BadgeIconAccessType = Exclude<
  AccessType,
  AccessType.EVENT | AccessType.MUSIC
>;

export const badgeIcons = {
  top: "flame",
  post: "text_box",
  video: "video",
  experience: "star",
  chat: "chat",
  merch: "merch",
  dj_set: "dj_set",
} as const satisfies Record<BadgeIconAccessType, IconName>;
